<template>
	<div class="ticket-detail-route">
		<template v-if="isReady">
			<div v-if="isNewTicket" class="new-request-page show-scrollbar">
				<header class="new-request-header">
					<button type="button" class="request-back" @click="returnToList()">
						<portal-icon name="arrow-left" :size="16"></portal-icon>
						{{ $t('requests.page-heading') }}
					</button>
					<h1>{{ pageHeader }}</h1>
				</header>
				<section class="new-request-shell">
					<new-ticket
						:ticket-types="ticketTypes"
						@cancel="returnToList()"
						@new-ticket="newTicket($event)"
					></new-ticket>
				</section>
			</div>
			<existing-ticket
				v-else
				:id="id"
				:ticket-types="ticketTypes"
				@back="returnToList()"
				@cancel="returnToList()"
			></existing-ticket>
		</template>
		<div v-else class="ticket-detail-loading">
			<v-progress-circular indeterminate :size="36" :width="3" color="primary"></v-progress-circular>
		</div>
	</div>
</template>

<script>
	import NewTicket from '@/modules/tickets/NewTicket';
	import ExistingTicket from '@/modules/tickets/ExistingTicket';
	import TicketService from '@/modules/tickets/TicketService';

	export default {
		name: 'TicketDetail',

		props: ['id'],

		components: { NewTicket, ExistingTicket },

		data: function() {
			return {
				ticketTypes: [],
				ticketService: new TicketService(),
				isReady: false,
			};
		},

		mounted() {
			this.getTicketSettings();
		},

		beforeDestroy() {},

		methods: {
			getTicketSettings: function() {
				this.ticketService.getTicketTypes().then((res) => {
					this.ticketTypes.splice(0, this.ticketTypes.length);
					this.ticketTypes.push(...res.data);
					this.isReady = true;
				});
			},

			returnToList: function() {
				this.$router.push('/requests');
			},

			newTicket: function(ticketId) {
				this.$router.push(`/requests/${ticketId}`);
			},
		},

		computed: {
			isNewTicket: function() {
				return this.id === 'new';
			},

			pageHeader: function() {
				if (this.id === 'new') {
					return this.$t('requests.new.heading');
				} else {
					return this.$t('requests.page-heading');
				}
			},
		},
	};
</script>

<style scoped lang="scss">
	.ticket-detail-route {
		min-height: 100%;
	}

	.ticket-detail-loading {
		min-height: 320px;
		display: grid;
		place-items: center;
	}

	.new-request-page {
		height: 100%;
		padding: 0 16px 28px;
		overflow-y: auto;
		text-align: left;
	}

	.new-request-header {
		padding: 14px 0 18px;
		border-bottom: 1px solid var(--portal-border);
	}

	.request-back {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		padding: 5px 7px 5px 3px;
		border: 0;
		border-radius: var(--brand-button-radius, 8px);
		background: transparent;
		color: var(--portal-muted);
		font: inherit;
		font-size: 12px;
		font-weight: 650;
		cursor: pointer;
	}

	.request-back:hover {
		background: var(--v-gray_20-base);
		color: var(--portal-text);
	}

	.request-back:focus-visible {
		outline: 2px solid var(--v-primary-base);
		outline-offset: 2px;
	}

	.new-request-header h1 {
		margin: 10px 0 0;
		color: var(--portal-text);
		font-size: clamp(22px, 3vw, 30px);
		font-weight: 700;
		letter-spacing: -0.025em;
	}

	.new-request-shell {
		max-width: 820px;
		margin-top: 18px;
		padding: 16px;
		border: 1px solid var(--portal-border);
		border-radius: var(--brand-surface-radius, 14px);
		background: var(--portal-surface);
	}

	.new-request-shell ::v-deep > .mx-3 {
		margin: 0 !important;
	}

	.new-request-shell ::v-deep > .mt-3 {
		margin-top: 0 !important;
	}

	.new-request-shell ::v-deep .container {
		padding: 0;
	}

	@media (max-width: 599px) {
		.new-request-page {
			padding: 0 12px 20px;
		}

		.new-request-shell {
			padding: 12px;
		}
	}
</style>
